<div class="orgApp-d-flex orgApp-gap-8 orgApp-ht-40">
    <mat-form-field appearance="outline"
        class="orgApp-dp orgApp-cs-form-field orgApp-input-field orgApp-field-rounded-sm" [ngClass]="{
                error: momentDate.hasError('invalidDate')
              }" [ngStyle]="{'width':width}">
        <mat-label>{{
            dateLabel | translate
            }}</mat-label>
        <input #dateInput matInput [min]="minimumDate" [disabled]="!canEditDate" [max]="maxDate" [matDatepicker]="dp"  [formControl]="momentDate"
         placeholder="{{datePlaceHol | translate}}" (blur)="onInputBlur($event)"  />
        @if (momentDate.hasError('invalidDate'))
        {
        <mat-error>
            {{
            "common_error.pattern_error.message" | translate
            }}
        </mat-error>
        }

    </mat-form-field>
    <mat-datepicker-toggle matIconSuffix [for]="dp" [disabled]="!canEditDate" [ngClass]="{'orgApp-dp-cal-disabled-button': !canEditDate}"
        class="orgApp-dp-cal-button orgApp-dp-add-cal-btn orgApp-align-i-center orgApp-justify-c-center"></mat-datepicker-toggle>
    <mat-datepicker #dp panelClass="orgApp-dp-calendar" class="orgApp-dp-calendar" [startAt]="startAtDate"
        ></mat-datepicker>
    <!-- <button type="button" mat-icon-button [disabled]="!canEditDate" [matMenuTriggerFor]="calendarMenu"
        [ngClass]="{'orgApp-staff-disabled-button': !canEditDate}"
        class="orgApp-dp-cal-button orgApp-dp-add-cal-btn orgApp-align-i-center orgApp-justify-c-center">
        <svg width="16" height="16">
            <use [attr.xlink:href]="canEditDate ? '#calendar-blue-icon' : '#calendar-disabled-icon'"></use>
        </svg>
    </button>
    <mat-menu #calendarMenu="matMenu">
        <mat-calendar class="orgApp-dp-calendar" (click)="$event.stopPropagation()" style="width: 15rem"
            [startAt]="startAtDate" [minDate]="minimumDate" [maxDate]="maxDate" #calendar
            maxDate="{{ currentDate | date : 'yyyy-MM-dd' }}" [(selected)]="selectedDate"
            (selectedChange)="onDateChange($event)" panelClass="orgApp-dp-calendar">
        </mat-calendar>
    </mat-menu> -->
</div>